import { getDomain,getCookie,getCommonSessionId} from '@/pc.config.js';
let isWxClient =  () => {
	var ua = navigator.userAgent.toLowerCase();
	if (ua.match(/micromessenger/i) == 'micromessenger') {
		return true;
	} else if (ua.indexOf('micromessenger') != -1) {
		return true;
	}
	return false;
}
let checkLogin = (hasLoginCb, failLoginCb) => {
	if (getCookie(getCommonSessionId()) && getCookie(getCommonSessionId()) != '') {
		hasLoginCb && hasLoginCb();
	} else {
		failLoginCb && failLoginCb()
	}
}
  // 是否是ipx
let isIphoneX = () => {
	// 兼容ipx底部
	if (/iphone/gi.test(window.navigator.userAgent)) {
		/* iPhone X、iPhone XS */
		var x = (window.screen.width === 375 && window.screen.height === 812);
		/* iPhone XS Max */
		var xsMax = (window.screen.width === 414 && window.screen.height === 896);
		/* iPhone XR */
		var xR = (window.screen.width === 414 && window.screen.height === 896);
		if (x || xsMax || xR) {
			return true;
		} else {
			return false;
		}
	} else {
		return false
	}
} 
let throttle = (fn, delay) => {
	let canClick = true;
	let context = this;
	return function () {
		if (canClick) {
			fn.call(context, arguments)
			canClick = false
			setTimeout(() => {
				canClick = true
			}, delay)
		}
	}
}
let leftTimer = (time, delay) => {
   let startTime = time
   return function() {
	startTime--
	return startTime
	//   setTimeout( () => {
	// 	startTime --
	// 	if(startTime > 0) {
    //        leftTimer(time, delay)()
	// 	}
	// 	return startTime
	//   }, delay)
   }
}

let timeFormate = (timestamp, types) => {
	let date = new Date(timestamp);
	let Y = date.getFullYear();
	let M = (date.getMonth()+1 < 10 ? ''+(date.getMonth()+1) : date.getMonth()+1);
	let D = (date.getDate() < 10 ? ''+date.getDate() : date.getDate());
	let h = (date.getHours() < 10 ? '0'+date.getHours() : date.getHours());
	let m = (date.getMinutes() < 10 ? '0'+date.getMinutes() : date.getMinutes());

	if(types == 0) {//返回月-日
			return M+'-'+D;
	}

	if(types == 1) {//返回格式 3月12日 20:00
			return M+'月'+D+'日 '+h+':'+m;
	}

	if(types == 2) {//返回格式 2020年3月12日
			return Y + '年'+ M+'月'+D+'日';
	}

	if(types == 3) {//返回格式 2020年3月12日
		return Y + '年'+ M+'月'+D+'日 '+h+':'+m;
	}
}

let GetRequest = () => {
  var url = location.search; //获取url中"?"符后的字串
  var theRequest = new Object();
  if (url.indexOf('?') != -1) {
    var str = url.substr(1);
    str = str.split('&');
    for (var i = 0; i < str.length; i++) {
      theRequest[str[i].split('=')[0]] = unescape(str[i].split('=')[1]);
    }
  }
  return theRequest;
}

export default {
	isWxClient, checkLogin, isIphoneX, throttle, leftTimer, timeFormate, GetRequest
}


// WEBPACK FOOTER //
// ./src/lib/app.js